module.exports = __webpack_public_path__ + "static/media/sft_data_example.e5699354.png";